import axios from '@/utils/axiosRequest'
// // 登录接口
// export const Loginnterface = (data) => {
//   return axios.request({
//     url: '/notelogin',
//     method: 'POST',
//     data
//   })
// }
// // 验证码
// export const Verificationcode = (data) => {
//   return axios.request({
//     url: '/note/getnote',
//     method: 'POST',
//     data
//   })
// }
// // 注册
// export const registered = (data) => {
//   return axios.request({
//     url: '/noteadd',
//     method: 'POST',
//     data
//   })
// }
// // token 验证
// export const Tokenauthentication = (data) => {
//   return axios.request({
//     url: '/note/jwttoken',
//     method: 'POST',
//     data
//   })
// }
// // 修改密码获取验证码接口
// export const passwordcode = (data) => {
//   return axios.request({
//     url: '/note/finn_back',
//     method: 'POST',
//     data
//   })
// }
// // 修改密码接口
// export const finnbnoteverifyack = (data) => {
//   return axios.request({
//     url: '/note/noteverify',
//     method: 'POST',
//     data
//   })
// }

// // 修改密码接口
// export const thepassword = (data) => {
//   return axios.request({
//     url: '/note/upnote',
//     method: 'POST',
//     data
//   })
// }
// //获取软件使用人数
// export const Useofsoftware = (data) => {
//   return axios.request({
//     url: '/note/loadlist',
//     method: 'POST',
//     data
//   })
// }
// //获取访问人数
// export const Numberofvisitors = (data) => {
//   return axios.request({
//     url: '/note/viewlist',
//     method: 'POST',
//     data
//   })
// }

// //查询评论
// export const selectone = (data) => {
//   return axios.request({
//     url: '/note/selectone',
//     method: 'POST',
//     data
//   })
// }
// //查询回复评论
// export const selectoneleaves = (data) => {
//   return axios.request({
//     url: '/note/selectoneleaves',
//     method: 'POST',
//     data
//   })
// }
// //发表评论
// export const leaves = (data) => {
//   return axios.request({
//     url: '/note/leaves',
//     method: 'POST',
//     data
//   })
// }
// //删除评论
// export const alldelone = (data) => {
//   return axios.request({
//     url: '/note/alldelone',
//     method: 'POST',
//     data
//   })
// }

// //回复楼主
// export const oneleaves = (data) => {
//   return axios.request({
//     url: '/note/oneleaves',
//     method: 'POST',
//     data
//   })
// }
// //撤回回复楼主
// export const delwrite = (data) => {
//   return axios.request({
//     url: '/note/delwrite',
//     method: 'POST',
//     data
//   })
// }
// //获取评论人数
// export const hqplrs = (data) => {
//   return axios.request({
//     url: '/note/hqplrs',
//     method: 'POST',
//     data
//   })
// }
//获取产品
// export const selsxxm = (data) => {
//   return axios.request({
//     url: '/api/note/selsxxm',
//     method: 'POST',
//     data
//   })
// }
// //获取首页视频
// export const course = (data) => {
//   return axios.request({
//     url: '/api/note/course',
//     method: 'POST',
//     data
//   })
// }
//获取轮播图
export const photo = (data) => {
  return axios.request({
    url: '/func/photo',
    method: 'POST',
    data
  })
}
//获取职位信息
export const seljoinus = (data) => {
  return axios.request({
    url: '/func/seljoinus',
    method: 'POST',
    data
  })
}
//删除班级人数具体
export const insforum = (data) => {
  return axios.request({
    url: '/weilai/insforum',
    method: 'POST',
    data
  })
}

//回复评论
export const inswrite = (data) => {
  return axios.request({
    url: '/weilai/inswrite',
    method: 'POST',
    data
  })
}

//获取我的信息
export const selecforum = (data) => {
  return axios.request({
    url: '/weilai/selecforum',
    method: 'POST',
    data
  })
}
//获取详细内容
export const onepublic = (data) => {
  return axios.request({
    url: '/note/onepublic',
    method: 'POST',
    data
  })
}
//获取产品列表
export const selproduct = (data) => {
  return axios.request({
    url: '/func/selproduct',
    method: 'POST',
    data
  })
}
//获取资料
export const selectcoll = (data) => {
  return axios.request({
    url: '/weilai/selectcoll',
    method: 'POST',
    data
  })
}
//获取合作企业
export const selectcol = (data) => {
  return axios.request({
    url: '/func/selectcoll',
    method: 'POST',
    data
  })
}
//获取合作企业
export const selectbrief = (data) => {
  return axios.request({
    url: '/weilai/selectbrief',
    method: 'POST',
    data
  })
}
//联系我们
export const insetleaveword = (data) => {
  return axios.request({
    url: '/note/insetleaveword',
    method: 'POST',
    data
  })
}
//获取通知公告
export const selvypublics = (data) => {
  return axios.request({
    url: '/note/selvypublics',
    method: 'POST',
    data
  })
}




